import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-textile-model-category5-lang',
  templateUrl: './textile-model-category5-lang.component.html',
  styleUrls: ['./textile-model-category5-lang.component.css']
})
export class TextileModelCategory5LangComponent implements OnInit {
    textileModelCategory5Keyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.textileModelCategory5Keyno = this.stateService.getStateParams()['textilemodelcategory5_keyno'];
    }

    private async loadLanguages() {
        if (!!this.textileModelCategory5Keyno) {
            this.inputListLanguages = await this.datatask.Post(2688, { textilemodelcategory5_keyno: this.textileModelCategory5Keyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2689, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    textilemodelcategory5_keyno: number;
    textilemodelcategory5lang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory5Lang', {
//        templateUrl: 'views/components/views/textileModelCategory5Lang/textileModelCategory5Lang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'textileModelCategory5LangService', function ($stateParams, stateService, textileModelCategory5LangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory5Keyno = $stateParams.textilemodelcategory5_keyno;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory5Languages() {
//                vm.model.inputListLanguages = await textileModelCategory5LangService.listTextileModelCategory5Languages({ textilemodelcategory5_keyno: textileModelCategory5Keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory5LangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory5Languages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
